import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';

/**
 * Custom strategy that forces Angular to destroy and recreate a component
 * when the URL segments change, even within the same route config (e.g. '**' wildcard).
 *
 * The default Angular strategy reuses the component if the route config is the same,
 * which means navigating from /apostille to /notary (both matching '**') keeps the
 * old component alive and ngOnInit never re-fires.
 */
export class CustomRouteReuseStrategy implements RouteReuseStrategy {
    shouldDetach(_route: ActivatedRouteSnapshot): boolean { return false; }
    store(_route: ActivatedRouteSnapshot, _handle: DetachedRouteHandle | null): void { }
    shouldAttach(_route: ActivatedRouteSnapshot): boolean { return false; }
    retrieve(_route: ActivatedRouteSnapshot): DetachedRouteHandle | null { return null; }

    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        // Only reuse if route config is the same AND URL segments are identical
        return future.routeConfig === curr.routeConfig &&
               future.url.toString() === curr.url.toString();
    }
}
